import template from './template.html'

export default {
  bindings: {
    itemGroup: '<',
    categories: '<'
  },
  template
}
